import React from "react"
import topCatData from "../../data/topCategory"
import TopCatCard from "../product-card/topSellingCard"

const createCard = data => {
  return <TopCatCard name={data.name} link={data.link} image={data.image} />
}

export default function TopCategorie() {
  return (
    <div className="top-categorie">
       <div className="home-heading">
        <h2>Shop from top Categories</h2>
      </div>
      <div className="d-flex overflow-auto">
        {topCatData.map(createCard)}
      </div>
    </div>
  )
}
